import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoExpandDirective } from '@commons/auto-expand/auto-expand.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [AutoExpandDirective],
  exports: [AutoExpandDirective],
})
export class AutoExpandModule {}
